import $ from 'jquery';
import whatInput from 'what-input';

window.$ = $;

import Foundation from 'foundation-sites';
import lightbox2 from 'lightbox2';

// If you want to pick and choose which modules to include, comment out the above and uncomment
// the line below
//import './lib/foundation-explicit-pieces';

$(document).foundation();

$(document).ready(function(){
	$('#nav-icon').click(function(){
		$(this).toggleClass('open');
		changeLabel();
		revealOverlay();
	});
});

$(document).ready(function(){
	$('#nav-icon-mobile').click(function(){
		$(this).toggleClass('open');
		changeLabelMobile();
		revealOverlayMobile();
	});
});

//////////////////////////////
// Reveal menu with revealOverlay()
//////////////////////////////

function revealOverlay() {
  document.getElementById("myNav").classList.toggle("overlay-reveal");
  document.body.classList.toggle('noscroll');
}

function revealOverlayMobile() {
  document.getElementById("myNav").classList.toggle("overlay-reveal");
  document.body.classList.toggle('noscroll');
}

function changeLabel() {
  var x = document.getElementById("changeLabel");
  if (x.innerHTML === "Meny") {
    x.innerHTML = "Lukk";
  } else {
    x.innerHTML = "Meny";
  }
}

function changeLabelMobile() {
  var x = document.getElementById("changeLabelMobile");
  if (x.innerHTML === "Meny") {
    x.innerHTML = "Lukk";
  } else {
    x.innerHTML = "Meny";
  }
}
